var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.room
    ? _c(
        "div",
        { attrs: { id: "room-remote-management" } },
        [
          _c("div", { staticClass: "va-subtitle flex align-center" }, [
            _c("div", { staticClass: "va-subtitle flex align-center" }, [
              _vm._v(" " + _vm._s(_vm.$t("roomCommands.logging")) + " ")
            ])
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "div",
                    { staticClass: "flex justify-space-between align-center" },
                    [
                      _c("v-select", {
                        staticClass: "mr-8",
                        attrs: {
                          outlined: "",
                          dense: "",
                          items: _vm.logLevels,
                          "item-value": "value",
                          "item-text": "text",
                          loading: _vm.updating,
                          disabled:
                            !_vm.room.online || _vm.room.isMaintenanceExpired,
                          label: _vm.$t("roomCommands.logLevel")
                        },
                        model: {
                          value: _vm.currentLogLevel,
                          callback: function($$v) {
                            _vm.currentLogLevel = $$v
                          },
                          expression: "currentLogLevel"
                        }
                      }),
                      _c("va-button", {
                        staticClass: "mb-4 mr-8",
                        attrs: {
                          disabled:
                            !_vm.room.online ||
                            _vm.sending ||
                            _vm.room.isMaintenanceExpired,
                          loading: _vm.updating,
                          cta: _vm.$t("roomCommands.setLogLevel")
                        },
                        on: { click: _vm.changeLogLevel }
                      }),
                      _c("va-button", {
                        staticClass: "mb-4",
                        attrs: {
                          disabled:
                            !_vm.room.online ||
                            _vm.sending ||
                            _vm.updating ||
                            _vm.room.isMaintenanceExpired,
                          cta: _vm.$t("common.downloadLog")
                        },
                        on: { click: _vm.downloadLog }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        "content-class": "fullscreen card",
                        scrollable: ""
                      },
                      model: {
                        value: _vm.downloading,
                        callback: function($$v) {
                          _vm.downloading = $$v
                        },
                        expression: "downloading"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", [
                            _c("h3", [
                              _vm._v(_vm._s(_vm.$t("common.downloadingLog")))
                            ])
                          ]),
                          _c(
                            "v-card-text",
                            [
                              _c("v-progress-linear", {
                                attrs: { indeterminate: "", color: "primary" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    outlined: "",
                                    color: "error"
                                  },
                                  on: { click: _vm.stopDownload }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("common.stop")) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }